
import { useState } from "react";

const InlineHoverTabs = ({tabs}) => {
  const [hoverTab, setHoverTab] = useState(null);

  return (
    <div className="flex  ">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className="relative  text-blue-600 x text-[10px] font-medium cursor-pointer"
          onMouseEnter={() => setHoverTab(tab.id)}
          onMouseLeave={() => setHoverTab(null)}
        >
       <div className="flex justify-center items-center w-14 h-6">
        <span>{tab.content}</span>
      </div>

          {hoverTab === tab.id && (
            <div className="absolute items-center flex justify-center top-5 left-0 w-14 h-5 px-1 py-1  bg-secondary border rounded-md  text-four text-[7px]">
              {tab.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default InlineHoverTabs;
